import React from 'react';
const DescriptionsContext = React.createContext(null);
export default DescriptionsContext;
